const cropText = (text: string, charLimit: number = 50) => {
  return text.length > charLimit ? text.slice(0, charLimit - 5) + "..." : text;
};

export default cropText;
